import { Theme } from '@app/theme';
import { useFormikContext } from 'formik';
import { ProspectActionEnum, QuoteInformation, StudyType } from 'queries';
import { useTranslation } from 'react-i18next';
import { createUseStyles } from 'react-jss';
import { BookWithSalesButton } from '../../components/BookWithSalesButton';

const useStyles = createUseStyles((theme: Theme) => ({
  finalActionsButtons: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: theme.marginBase * 2,
    marginTop: theme.marginBase * 5,
  },
}));

export const TalkToSalesSection = () => {
  const { t } = useTranslation();
  const { values } = useFormikContext<Partial<QuoteInformation>>();
  const classes = useStyles();

  return (
    <div className={classes.finalActionsButtons}>
      <BookWithSalesButton
        text={t('studySetup.generalSetup.talkToSales.noQuote')}
        modalTitle={t('studySetup.generalSetup.talkToSales.modal.title')}
        modalDescription={t(
          'studySetup.generalSetup.talkToSales.modal.description',
        )}
        submitText={t('studySetup.generalSetup.talkToSales.modal.submit')}
        action={
          values.studyType === StudyType.DIARY
            ? ProspectActionEnum.REQUEST_DISCUSS
            : ProspectActionEnum.REQUEST_QUOTE
        }
        studySetupInfo={values}
      />
    </div>
  );
};
